/* notice-touch-axis.js — shared iOS touch-axis lock for horizontal carousels.
   Extracted verbatim from the former inline <script> in snippets/notice-touch-axis.liquid
   so the browser caches it once instead of receiving it inline on every render.
   Idempotent: declares window.noticeBindTouchAxis once, so it is safe to load from
   more than one section/block on the same page.
   Usage:
     noticeBindTouchAxis(el, {
       shouldIgnore: function(e) { return bool; },
       onStart:      function(e) {},
       onPanX:       function(e) {},
       onEnd:        function(wasHorizontal, state) {},
       suppressClick: true|false
     });
*/
(function () {
  if (window.noticeBindTouchAxis) return;
  window.noticeBindTouchAxis = function (el, opts) {
    if (!el || el._noticeTouchAxisBound) return;
    el._noticeTouchAxisBound = true;
    opts = opts || {};
    var st = null;

    function finish(e) {
      if (!st) return;
      if (e && e.pointerId !== st.id) return;
      var hor = st.axis === 'x';
      if (hor && el.releasePointerCapture) {
        try { el.releasePointerCapture(st.id); } catch (_) {}
      }
      el.classList.remove('is-horizontal-panning', 'is-vertical-panning');
      el.style.scrollBehavior = '';
      if (opts.onEnd) opts.onEnd(hor, st);
      st = null;
    }

    el.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      if (opts.shouldIgnore && opts.shouldIgnore(e)) return;
      st = { id: e.pointerId, startX: e.clientX, startY: e.clientY, startLeft: el.scrollLeft, axis: null };
      el.style.scrollBehavior = 'auto';
      el.scrollTo({ left: el.scrollLeft, behavior: 'auto' });
      if (opts.onStart) opts.onStart(e);
    });

    el.addEventListener('pointermove', function (e) {
      if (!st || e.pointerId !== st.id) return;
      var dx = e.clientX - st.startX, dy = e.clientY - st.startY;
      var ax = Math.abs(dx), ay = Math.abs(dy);
      if (!st.axis) {
        if (Math.max(ax, ay) < 8) return;
        st.axis = ax > ay * 1.2 ? 'x' : 'y';
        if (st.axis === 'x') {
          el.classList.add('is-horizontal-panning');
          if (el.setPointerCapture) {
            try { el.setPointerCapture(st.id); } catch (_) {}
          }
        } else {
          el.classList.add('is-vertical-panning');
          return;
        }
      }
      if (st.axis === 'x') {
        if (e.cancelable) e.preventDefault();
        var mult = opts.dragMultiplier || 1;
        el.scrollLeft = st.startLeft - dx * mult;
        if (opts.onPanX) opts.onPanX(e);
      }
    }, { passive: false });

    el.addEventListener('pointerup', finish);
    el.addEventListener('pointercancel', finish);

    if (opts.suppressClick) {
      el.addEventListener('click', function (e) {
        if (!el._noticeSuppressClick) return;
        el._noticeSuppressClick = false;
        e.preventDefault();
        e.stopPropagation();
      }, true);
    }
  };
})();
